import { render, staticRenderFns } from "./ForgotPasswordLoggedUser.vue?vue&type=template&id=04072599&scoped=true"
import script from "./ForgotPasswordLoggedUser.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordLoggedUser.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordLoggedUser.vue?vue&type=style&index=0&id=04072599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04072599",
  null
  
)

export default component.exports